module.exports = __webpack_public_path__ + "img/no_real_name.b36906d2.svg";